<!-- 真相搜索 - 根组件 -->


<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!--<router-link to="/">hello</router-link>-->
    <!--<router-link to="/index">index</router-link>-->
    <!--<Index></Index>-->
    <s-header :user="user"></s-header>

    <router-view></router-view>
     <swiper-drawer v-if="$route.path=='/'"></swiper-drawer>
    <content-footer v-if="conFooter"></content-footer>
    <s-footer v-if="showFooter"></s-footer>

    <login v-if="showLogin" @loggedIn="getUserAccount"></login>
    <register v-if="showRegister"></register>
    <msg-modal></msg-modal>
    <loading v-if="showLoading"></loading>
    <user-agree v-if="showUserAgree"></user-agree>
    <about-truthso v-if="showAboutTruthso"></about-truthso>
    <img class="bg_img" src="./assets/hp_background.png" v-if="showSBg">

    <!--<not-support  v-if="notSupport"></not-support>-->
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import tools from '@/lib/tools'
  import 'babel-polyfill'
 import swiperDrawer from "./components/common/swiperDrawer.vue"
  import Index from './components/Index'
  import SHeader from './components/common/SHeader'
  import SFooter from './components/common/SFooter'
  import Login from './components/user/Login'
  import Register from './components/user/Register'
  import MsgModal from './components/common/MsgModal.vue'
  import Loading from './components/common/Loading';
  import NotSupport from './components/others/NotSupport';
  import UserAgree from './components/others/UserAgree'
  import AboutTruthso from './components/others/AboutTruthso'
  import contentFooter from './components/common/contentFooter'

  import './assets/css/common.css'

  export default {
    name: 'app',
    components: {Index, SHeader, SFooter, Login, Register, MsgModal,Loading, NotSupport,UserAgree, contentFooter, AboutTruthso,swiperDrawer},
    created(){
      var info = localStorage.getItem('IP360');
      if(info){
        this.user = JSON.parse(info).user;
        this.$store.commit('login', this.user);
      }
      let fullPath = this.$router.history.current.fullPath;
      if (fullPath.indexOf('feedback') != -1) {
        //在反馈页面
        this.$store.commit('setCurrentHeader', 'feedback');
      }

    },
    data () {
      return {
        user:{},
        notSupport: false
      }
    },
    methods: {
      getUserAccount(user){
        this.user = user;
      },
      alerted(){
          this.$setLocalStorage('hasAlert', '1');
      }
    },
    computed: {

      //获取 store 中的相应状态
      ...mapState({
        showLogin: state => state.loginWin,
        showRegister: state => state.registerWin,
        showFooter: state => state.sFooter,
        showLoading: state => state.isLoading,
        showUserAgree: state=>state.userAgreeState,
        showSBg: state=>state.sBg,
        conFooter: state=>state.conFooter,
        showAboutTruthso: state=>state.aboutTruthso
      })
    }
  }
</script>

<style>
  html{
    min-height: 100%;
  }
  #app {
    font-family: "Microsoft YaHei", tahoma, arial, "Hiragino Sans GB", "\\5b8b体", sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: visible !important;
    height: 100% !important;
    /*text-align: center;*/
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  a {
    text-decoration: none;
    color: inherit;
    font-size: inherit;
  }
  input {
    outline: 0;
  }

  div {
    position: relative;
  }

  ul.nav {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul.nav > li {
    list-style: none;
    padding: 0;
    margin: 0;
    display: inline-block;
  }

  ul.nav-vertical{
    list-style: none;
    padding: 0;
    margin: 0;
  }
  ul.nav-vertical > li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  ::-ms-clear,::-ms-reveal{
    display: none;
  }
  .simulate-placeholder{
    color:#c3c3c3;
    font-size: 14px;
    padding-left: 20px;
    position: absolute;
    top:16px;
  }
  .bg_img {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
</style>



// WEBPACK FOOTER //
// App.vue?79453ff0